import React, { useState } from 'react';
import CoachPageLayout from '../../components/CoachPageLayout/CoachPageLayout';
import ArchivedClients from '../../components/ClientTable/ArchivedClients/ArchivedClients';
import { PaginationModelChangeProps } from '../../components/ClientTable/ClientTable';
import SubscriptionBanner from '../../components/SubscriptionBanner/SubscriptionBanner';

export interface ClientsProps {
  pageSize: number;
  currentPage: number;
  skip: number;
  handleOnPaginationModelChange: (_event: PaginationModelChangeProps) => void;
}

const ArchivedClientsView = () => {
  // Archived clients pagination
  const [pageSizeArchived, setPageSizeArchived] = useState<number>(10);
  const [currentPageArchived, setCurrentPageArchived] = useState<number>(0);
  const skipArchived = currentPageArchived * pageSizeArchived;

  const handlePaginatiChangeArchived = (event: PaginationModelChangeProps) => {
    setPageSizeArchived(event.pageSize);
    setCurrentPageArchived(event.page);
  };

  return (
    <CoachPageLayout>
      <ArchivedClients
        pageSize={pageSizeArchived}
        currentPage={currentPageArchived}
        skip={skipArchived}
        handleOnPaginationModelChange={handlePaginatiChangeArchived}
      />
      <SubscriptionBanner />
    </CoachPageLayout>
  );
};

export default ArchivedClientsView;
